import React from 'react';
import PropTypes from 'prop-types';
import Text, {TextType} from '../Text';
import Image, { ImageDataType } from '../Image';
import PageSectionTitle, { PageSectionTextType } from '../PageSectionTitle';
import Icon from '../Icons/Icon';
import Button from '../Button';
import { isDesktop } from '../../utility/domHelpers';

import './DescriptionRow.scss';

const className = 'c-DescriptionRow';

const DescriptionRow = ({
  title,
  imgSrc,
  description,
  ctaProps,
  reversed,
  customRender,
}) => {
  const reversedClassName = reversed ? `${className}__reversed` : '';

  return (
    <div className={`${className} ${reversedClassName}`}>
      <div className={`${className}__content-wrapper ${className}__left-side`}>
        <PageSectionTitle title={title} />

        {!isDesktop && (
          <div>
            <Image {...imgSrc} />
          </div>
        )}

        <Text text={description} />

        {ctaProps && (
          <Button
            onClick={ctaProps.onClick}
            displayType="primary"
            fluid
            newVersion={true}
          >
            <div className={`${className}__cta`}>
              {ctaProps.icon && <Icon name={ctaProps.icon} />}{' '}
              <span>{ctaProps.label}</span>
            </div>
          </Button>
        )}
        {customRender()}
      </div>
      {isDesktop && (
        <div className={`${className}__right-side`}>
          <Image {...imgSrc} />
        </div>
      )}
    </div>
  );
};

DescriptionRow.propTypes = {
  title: PageSectionTextType,
  imgSrc: PropTypes.shape(ImageDataType),
  description: TextType,
  ctaProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  }),
  reversed: PropTypes.bool,
  customRender: PropTypes.func,
};

DescriptionRow.defaultProps = {
  customRender: () => null,
};

export default DescriptionRow;
